export enum PHONE_NUMBER_VERIFICATION_STEPS {
    ENTER_PHONE_NUMBER = 'enterPhone',
    ENTER_OTP = 'enterOTP',
    VERIFICATION_COMPLETE = 'verificationComplete',
}